import { useState } from "react";
import RegularClassProvider from "src/provider/regularClassProvider";
import { z } from "zod";
import { Form } from "src/components/common/form";
import { Button } from "react-bootstrap";
import { useAttendancesQuery } from "src/services/react-query-apis/get-attendances";
import { usePutAttendancesMutation } from "src/services/react-query-apis/put-attendances";
import { swalConfirm, swalSuccess } from "src/utils/swalHelpers";
import { AttendanceFilter } from "./attendance-filter";
import { TransferAttendanceTable } from "./transfer-attendance-table";

export const TransferAttendance = () => {
  return (
    <RegularClassProvider>
      <TransferAttendanceBody />
    </RegularClassProvider>
  );
};

export const TransferAttendanceBody = () => {
  const [filterData, setFilterData] = useState({
    attendance_date: "",
    regular_class_schedule_id: 0,
  });

  const attendancesQuery = useAttendancesQuery({
    start_date: filterData.attendance_date,
    end_date: filterData.attendance_date,
    regular_class_schedule_id: filterData.regular_class_schedule_id,
    reschedulable_only: 0,
    bus_only: 0,
    queryConfig: {
      enabled: !!(
        filterData.attendance_date && filterData.regular_class_schedule_id
      ),
    },
  });

  const mutationConfig = {
    onSuccess: async data => {
      console.log(data);
      await swalSuccess(data.message);
    },
  };

  const putAttendancesMutation = usePutAttendancesMutation({
    mutationConfig,
  });

  return (
    <div style={{ width: "70%" }}>
      <div className="card-body">
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <div style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
              出席状況
            </div>
          </div>
          <div className="p-3">
            <AttendanceFilter
              onSubmit={values => {
                setFilterData(values);
              }}
            />
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>
          <Form
            key={
              attendancesQuery.isLoading
                ? "loading"
                : filterData.regular_class_schedule_id +
                  filterData.attendance_date
            }
            onSubmit={async values => {
              if (await swalConfirm("出席状況を変更しますか？")) {
                putAttendancesMutation.mutate({ data: values });
              }
            }}
            schema={z.object({
              attendances: z.array(
                z.object({
                  id: z.number().min(1, "出席状況を選択してください"),
                  status: z.enum(
                    ["absent", "attended", "absent_schcon", "absent_alert"],
                    {
                      errorMap: (issue, ctx) => ({
                        message: "選択してください",
                      }),
                    }
                  ),
                })
              ),
            })}
            options={{
              defaultValues: {
                attendances:
                  attendancesQuery.data?.data?.map(attendance => ({
                    id: attendance.id,
                    status: attendance.status,
                  })) || [],
              },
            }}
          >
            {() => {
              return (
                <div>
                  <TransferAttendanceTable
                    data={attendancesQuery.data?.data}
                    isLoading={attendancesQuery.isLoading}
                    isError={attendancesQuery.isError}
                  />
                  <div className="d-flex justify-content-end mt-3">
                    <Button
                      type="submit"
                      disabled={putAttendancesMutation.isPending}
                    >
                      {putAttendancesMutation.isPending ? "提出中..." : "提出"}
                    </Button>
                  </div>
                </div>
              );
            }}
          </Form>
        </div>
      </div>
    </div>
  );
};
